import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { parseMultipart2ddxudhdihg70 as parseMultipart } from './Multipart.mjs';
import { MultiPartData57syw40llxls as MultiPartData } from '../../../../../ktor-ktor-http/io/ktor/http/content/Multipart.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CIOMultipartDataBaseClass;
function CIOMultipartDataBase() {
  if (CIOMultipartDataBaseClass === VOID) {
    class $ {
      constructor(coroutineContext, channel, contentType, contentLength, formFieldLimit) {
        formFieldLimit = formFieldLimit === VOID ? 65536n : formFieldLimit;
        this.g57_1 = coroutineContext;
        this.h57_1 = null;
        this.i57_1 = parseMultipart(this, channel, contentType, contentLength, formFieldLimit);
      }
      sv() {
        return this.g57_1;
      }
    }
    initMetadataForClass($, 'CIOMultipartDataBase', VOID, VOID, [MultiPartData(), CoroutineScope()], [0, 1]);
    CIOMultipartDataBaseClass = $;
  }
  return CIOMultipartDataBaseClass;
}
//region block: exports
export {
  CIOMultipartDataBase as CIOMultipartDataBase3o5u8w437tq5s,
};
//endregion

//# sourceMappingURL=CIOMultipartDataBase.mjs.map
